import * as React from "react";
import styled, { css } from "styled-components";

const StyledAlert = styled.div<IStyleProps>`
  padding: 1rem 1.25rem;
  text-align: ${(props) => props.textAlign};
  border: 1px solid transparent;
  border-radius: ${({ noRadius }) => (noRadius ? 0 : ".25rem")};
  color: white;

  ${(props) =>
    props.type === "error" &&
    css`
      background-color: ${props.theme.colors.error};
    `}

  ${(props) =>
    props.type === "success" &&
    css`
      background-color: ${(props) => props.theme.colors.blueDark};
    `}
      
      ${(props) =>
    props.type === "warning" &&
    css`
      background-color: ${(props) => props.theme.colors.blueDark};
    `}
      
      ${(props) =>
    props.type === "info" &&
    css`
      background-color: ${(props) => props.theme.colors.blueDark};
    `}

    ${(props) =>
    (props.copnr || props.copnr === 0) &&
    css`
      background-color: ${props.theme.colors.elementStatus[props.copnr].bg};
      color: ${props.theme.colors.elementStatus[props.copnr].color};
    `}
`;

export const AlertItem = styled.p`
  margin-top: ${(props) => props.theme.space[1]};
  margin-bottom: ${(props) => props.theme.space[1]};
  color: currentColor;
`;

export const AlertWrap = styled.div`
  margin: ${(props) => props.theme.space[2]};
`;

export const AlertGroup = styled.div`
  margin-top: ${({ theme }) => theme.space[3]};
  margin-bottom: ${({ theme }) => theme.space[3]};
`;

interface IStyleProps {
  type: "error" | "success" | "warning" | "info" | "news";
  textAlign?: "start" | "center";
  noRadius?: boolean;
  copnr?: number | null;
}

interface IProps extends IStyleProps {
  children: React.ReactNode;
}

const Alert: React.FC<IProps> = ({
  children,
  textAlign = "center",
  type,
  noRadius = false,
  copnr = null,
}) => (
  <StyledAlert
    type={type}
    textAlign={textAlign}
    noRadius={noRadius}
    copnr={copnr}
  >
    {children}
  </StyledAlert>
);

export default Alert;
